import React from 'react';

function ChevronDownIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9,15.3c0.6,0.6,1.5,0.6,2,0l8.6-8.6c0.6-0.6,0.6-1.5,0-2c-0.6-0.6-1.5-0.6-2,0L10,12.3L2.4,4.7c-0.6-0.6-1.5-0.6-2,0s-0.6,1.5,0,2L9,15.3L9,15.3z"/>
    </svg>
  );
}

export default ChevronDownIcon;
